import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";

interface DeleteDialogProps {
  recipientName: string;
  recipientType: "payee" | "member";
  onDelete: () => void;
  isOpen: boolean;
  closeDialog: () => void;
}

const DeleteDialog = ({
  recipientName,
  recipientType,
  onDelete,
  isOpen,
  closeDialog,
}: DeleteDialogProps) => {
  const { l10n } = useLocalization();

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={closeDialog}
      // "plain" drops the NDS theme-colored header line; the grey divider is
      // the body's top border instead
      headerStyle="plain"
      title={
        <span className="fontSize--l fontWeight--semibold">
          {l10n.getString("recipients-delete-dialog-title", {
            recipientType,
          })}
        </span>
      }
      width="500px"
      testId="recipients-delete-dialog"
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              onClick={closeDialog}
              kind="negative"
              label={l10n.getString("button-cancel")}
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              onClick={onDelete}
              kind="primary"
              label={l10n.getString("button-yes-delete")}
            />
          </Row.Item>
        </Row>
      }
    >
      <div
        className="border--top margin--top--m padding--top--l"
        style={{ overflowWrap: "anywhere" }}
      >
        {l10n.getString("recipients-delete-dialog-message", {
          recipientType,
          name: recipientName,
        })}
      </div>
    </Dialog>
  );
};

export default DeleteDialog;
